import React, { useState } from 'react';

import {
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';

import { formattedCurrency, formattedDateTime } from '../../../../utils/utils';
import UITablePagination from '../../../UI/Table/Pagination/UITablePagination';

const initialClick = {
  mouseX: null,
  mouseY: null,
};

const ClosuresTable = (children) => {
  const {
    data,
    loading,
    error,
    actualIndex,
    doubleClickAction,
    disabled,
    onPrintClosure,
  } = children;

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  // ação para click direito e esquerdo
  const [clickRight, setClickRight] = useState(initialClick);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleCloseClickRight = () => {
    setClickRight(initialClick);
  };

  const handleCloseClickLeft = () => {
    setAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Aberto em</TableCell>
            <TableCell>Abriu com</TableCell>
            <TableCell>Aberto por</TableCell>
            <TableCell>Fechado em</TableCell>
            <TableCell>Fechou com</TableCell>
            <TableCell>Fechado por</TableCell>
            <TableCell align="center" style={{ width: 80 }}>
              Ações
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && <CircularProgress />}
          {data &&
            data
              .slice(
                page * rowsPerPage,
                rowsPerPage === -1
                  ? undefined
                  : page * rowsPerPage + rowsPerPage,
              )
              .map((value, _index) => {
                const realIndex = page * rowsPerPage + _index;
                return (
                  <TableRow
                    tabIndex={-1}
                    onDoubleClick={() =>
                      disabled ? {} : doubleClickAction(realIndex)
                    }
                    style={{
                      cursor: disabled ? 'wait' : 'pointer',
                      background: realIndex === actualIndex ? '#8ecae6' : '',
                    }}
                    hover
                    key={value.opened}
                  >
                    <TableCell component="th" scope="row">
                      {formattedDateTime(value.opened)}
                    </TableCell>
                    <TableCell>{formattedCurrency(value.initalValue)}</TableCell>
                    <TableCell>{value.openedBy}</TableCell>
                    <TableCell>{formattedDateTime(value.closed)}</TableCell>
                    <TableCell>{formattedCurrency(value.finalValue)}</TableCell>
                    <TableCell>{value.closedBy}</TableCell>
                    <TableCell align="center">
                      <Tooltip title="Imprimir este fechamento">
                        <span>
                          <IconButton
                            size="small"
                            color="primary"
                            disabled={disabled}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (onPrintClosure) onPrintClosure(realIndex);
                            }}
                          >
                            <PrintIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
          <Menu
            keepMounted
            open={clickRight.mouseY !== null}
            onClose={handleCloseClickRight}
            anchorReference="anchorPosition"
            anchorPosition={
              clickRight.mouseY !== null && clickRight.mouseX !== null
                ? {
                    top: clickRight.mouseY,
                    left: clickRight.mouseX,
                  }
                : undefined
            }
          >
            <MenuItem onClick={undefined}>Ver detalhes</MenuItem>
          </Menu>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => handleCloseClickLeft()}
          >
            <MenuItem onClick={undefined}>Ver detalhes</MenuItem>
          </Menu>
          {error && (
            <TableRow>
              <TableCell colSpan={7}>Sem resultados encontrados</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <UITablePagination
        count={data ? data.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};

export default ClosuresTable;

